import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ClosureDates } from "../model/ClosureDates";
import { Environment } from "../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EmailService {
  private accountPreferencesEndpoint: string;
  private accountPrefEmailEndpoint: string;
  //private currentEnvironment = this.getCurrentEnvironment();
  private accountPrefsAPIKey: string;
  private oeURL: string;

  private closureDate: ClosureDates;
  private accountPrefsArray = [];
  private addYearArray = [];
  private removeYearArray = [];

  constructor(
    private httpClient: HttpClient,
    private environment: Environment
  ) {
    this.accountPreferencesEndpoint = environment.getEnvironmentVariable(
      "accountPreferencesEndpoint"
    );
    this.accountPrefsAPIKey = environment.getEnvironmentVariable(
      "accountPrefsAPIKey"
    );
    this.accountPrefEmailEndpoint = environment.getEnvironmentVariable(
      "accountPrefEmailEndpoint"
    );
    this.oeURL = environment.getEnvironmentVariable("oe_url");
  }

  sendEmailWithMultipleAccounts(
    transactionId,
    userId,
    addedPreferences,
    removedPreferences,
    pharmAccts,
    pharmNames,
    firstName,
    email
  ) {
    const API_UPDATE_PREFS_EMAIL = this.accountPrefEmailEndpoint;

    let curOEUrl;
    if (this.oeURL === "https://orderexpresspmoddev.cardinalhealth.com") {
      curOEUrl =
        "https://nextgenpmoddev.cardinalhealth.com/#/?deeplink=preferences";
    } else if (
      this.oeURL === "https://orderexpresspmodstg.cardinalhealth.com"
    ) {
      curOEUrl =
        "https://nextgenstg.cardinalhealth.com/#/?deeplink=preferences";
    } else {
      curOEUrl = "https://nextgen.cardinalhealth.com/#/?deeplink=preferences";
    }

    let body = {};

    body = {
      transactionId: transactionId,
      userId: userId,
      firstName: firstName,
      email: email,
      link: curOEUrl,
      accountPreferenceDataList: this.buildAccountDataList(
        addedPreferences,
        removedPreferences,
        pharmAccts,
        pharmNames
      ),
    };

    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "x-api-key": this.accountPrefsAPIKey,
        Authorization: sessionStorage.getItem("accessToken"),
      }),
      responseType: "text" as "json",
    };
    return this.httpClient.put(
      API_UPDATE_PREFS_EMAIL,
      JSON.stringify(body),
      options
    );
  }

  buildAccountDataList(
    addedPreferences,
    removedPreferences,
    pharmAccts,
    pharmNames
  ) {
    let accountListItem = {};
    let accountListArray = [];
    // if (addedPreferences === undefined) addedPreferences = ''
    // if (removedPreferences === undefined) removedPreferences = ''

    for (let i = 0; i < pharmAccts.length; i++) {
      accountListItem = {
        addedPreferences: addedPreferences.join(),
        removedPreferences: removedPreferences.join(),
        key: `${pharmAccts[i]}|2020`,
        name: pharmNames[i],
      };
      accountListArray.push(accountListItem);
    }
    return accountListArray;
  }

  public getHeadersForEmailUpdateAccountPrefs(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "x-api-key": this.accountPrefsAPIKey,
        Authorization: sessionStorage.getItem("accessToken"),
      }),
      responseType: "text" as "json",
    };
    return httpOptions;
  }

  public buildAccoutList(addPrefs, removePrefs, pharmAccts, pharmName) {
    let splitStr;
    let year;

    if (addPrefs.length !== 0) {
      splitStr = addPrefs[0].split("/");
      year = splitStr[2];
    } else {
      splitStr = removePrefs[0].split("/");
      year = splitStr[2];
    }

    this.accountPrefsArray.push({
      addedPreferences: addPrefs.toString(),
      removedPreferences: removePrefs.toString(),
      key: pharmAccts + "|" + year,
      name: pharmName,
    });
  }
}
